
  import {Component, Vue, Prop} from "vue-property-decorator";
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";

  @Component({})
  export default class CarNumberCell extends Vue {
    @Prop() cell: IReport.ITableProp;
    @Prop() entity: IReport.IEvent | IMovementsReport.IDataItem;

    get value() { return this.entity[this.cell.prop]; }

    async openCarPopup() {
      if (this.entity.carId) {
        await this.$store.dispatch('car/openCarPopup', { carId: this.entity.carId });
      }
      else {
        let payload = {
          createMode: true,
          carNumber: this.entity.carNumber,
          presetFields: [
            {prop: 'carNumber', value: this.entity.carNumber,},
            {prop: 'corpId', value: this.entity.corpId,},
          ]
        };
        await this.$store.dispatch('car/openCarPopup', payload);
      }
    }
  }
